export const FETCHING_TAX_RESERVE_REPORT = 'FETCHING_TAX_RESERVE_REPORT';
export const FETCHING_TAX_RESERVE_REPORT_SUCCESS = 'FETCHING_TAX_RESERVE_REPORT_SUCCESS';
export const FETCHING_TAX_RESERVE_REPORT_FAILURE = 'FETCHING_TAX_RESERVE_REPORT_FAILURE';
export const FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS = 'FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS';
export const FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS_SUCCESS = 'FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS_SUCCESS';
export const FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS_FAILURE = 'FETCHING_TAX_RESERVE_REPORT_DATA_FOR_ALL_PILLS_FAILURE';
export const FETCH_OBLIGATIONS = 'FETCH_OBLIGATIONS';
